module.exports = __webpack_public_path__ + "img/logo.753549c6.svg";